module.exports = __webpack_public_path__ + "img/camera.b3d63676.webp";